import React from 'react';
import CustomTextField from 'components/Fileds/CustomTextFiled';
import CustomTypography from 'components/Fileds/CustomTypography';
import * as Yup from 'yup';
import GenericDialog from '../GenericDialog/GenericDialog';
import { Box, useTheme } from '@mui/material';
import CustomAutocomplete from 'components/Fileds/CustomAutocomplete';

const AssignChefSchema = Yup.object().shape({
  chefs: Yup.array().of(Yup.number()).min(1, 'At least one chef is required'),
});

const AssignChefModal = ({ open, onClose, initialData, onSubmit, loading, chefOptions = [] }) => {
  const theme = useTheme();

  return (
    <GenericDialog
      open={open}
      onClose={onClose}
      title={`Assign Chefs`}
      initialValues={{
        station: initialData?.name || '',
        chefs: initialData?.assignedChefs?.map(c => c.id) || [], // ✅ prefill with chef IDs
    }}
      validationSchema={AssignChefSchema}
      onSubmit={onSubmit}
      submitLabel="Assign"
      loading={loading}
      requiredFields={['chefs']}
      enableReinitialize   
    >
      {({ values, errors, touched, setFieldValue }) => (
        <>
          {/* Station Name - Disabled */}
          <Box sx={{ mb: 2 }}>
            <CustomTypography
              label="Station Name"
              sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
            />
            <CustomTextField
              name="station"
              value={values.station}
              fullWidth
              disabled
            />
          </Box>

          {/* Multi-select Chef */}
          <Box>
            <CustomTypography
              label="Assign Chefs"
              sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
            />
            <CustomAutocomplete
              multiple
              name="chefs"
              options={chefOptions}
              value={chefOptions.filter(opt => values.chefs.includes(opt.id))}  
              onChange={(_, newValue) => setFieldValue('chefs', newValue.map(v => v.id))}
              placeholder={values?.chefs?.length > 0 ? "" : "Select chefs"}
              error={touched.chefs && Boolean(errors.chefs)}
              helperText={touched.chefs && errors.chefs}
              getOptionLabel={(option) => option?.name || ''}
            />
          </Box>
        </>
      )}
    </GenericDialog>
  );
};

export default AssignChefModal;
